import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import posed from 'react-pose';

import Icon from 'common/icon';
import Button from 'common/button';

const Expander = posed.div({
    closed: { height: 0, opacity: 0 },
    open: { height: 'auto', opacity: 1 },
});

const TypeCard = ({ title, description, buttonLabel, onClick, expanded, active, disabled }) => {
    return (
        <button
            type="button"
            className={cx(
                'bg-white shadow p-8 rounded block w-full text-left h-full flex flex-col items-stretch',
                {
                    'md:pointer-events-none': disabled,
                }
            )}
            onClick={onClick}
        >
            <div>
                <div className="float-right -mt-px md:hidden">
                    {active ? (
                        <Icon
                            icon="check-circle"
                            type="solid"
                            size="lg"
                            className="text-green-50"
                        />
                    ) : (
                        <Icon icon="circle" type="regular" size="lg" className="text-gray-20" />
                    )}
                </div>
                <h2
                    className={cx('text-16 md:text-18 lg:text-21', {
                        'text-gray-20': disabled,
                        'text-gray-80': !disabled,
                    })}
                >
                    {title}
                </h2>
            </div>
            <Expander pose={expanded ? 'open' : 'closed'} className="overflow-hidden flex-grow">
                <p
                    className={cx('text-14 md:text-16 mt-4 leading-normal', {
                        'text-gray-50': !disabled,
                        'text-gray-30': disabled,
                    })}
                >
                    {description}
                </p>
            </Expander>
            <Button
                component="span"
                color={disabled ? 'light' : 'green'}
                size="md"
                className="hidden md:block w-full text-14 font-medium mt-8"
            >
                {buttonLabel}
            </Button>
        </button>
    );
};

TypeCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    expanded: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
};

TypeCard.defaultProps = {
    disabled: false,
};

export default TypeCard;
